/* Fade between full-page navigations */
(function () {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const duration = 260;

    if (reduceMotion) return;

    window.addEventListener('pageshow', function () {
        document.documentElement.classList.remove('is-page-exiting');
        document.body.style.opacity = '';
    });

    document.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const link = event.target.closest('a');
        if (!link || link.target === '_blank' || link.hasAttribute('download') || link.origin !== window.location.origin || link.pathname === window.location.pathname && link.hash) return;

        event.preventDefault();
        document.documentElement.classList.add('is-page-exiting');
        document.body.style.opacity = '0';
        window.setTimeout(function () {
            window.location.href = link.href;
        }, duration);
    }, true);
})();

/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    function setOpen(open) {
        navigation.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflowY = open ? 'hidden' : null;
    }

    burger.addEventListener('click', function () {
        setOpen(!navigation.classList.contains('is-open'));
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && navigation.classList.contains('is-open')) {
            setOpen(false);
            burger.focus();
        }
    });
})();

/* Spotlight: dots near the cursor grow and darken on the publication layout */
(function () {
    const layout = document.querySelector('.publication-layout');
    const enabled = window.matchMedia('(pointer: fine) and (min-width: 768px) and (prefers-reduced-motion: no-preference)');
    if (!layout || !enabled.matches) return;

    // Must match the dot grid in screen.css (.publication-layout background).
    const SPACING = 14;
    const RADIUS = 140;

    const canvas = document.createElement('canvas');
    canvas.className = 'publication-spotlight';
    canvas.setAttribute('aria-hidden', 'true');
    layout.prepend(canvas);
    const ctx = canvas.getContext('2d');

    const light = {x: 0, y: 0, tx: 0, ty: 0, amount: 0, target: 0, width: 0, height: 0};
    let frame = null;

    function resize() {
        const dpr = window.devicePixelRatio || 1;
        light.width = layout.clientWidth;
        light.height = layout.clientHeight;
        canvas.width = Math.round(light.width * dpr);
        canvas.height = Math.round(light.height * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        draw();
    }

    function draw() {
        ctx.clearRect(0, 0, light.width, light.height);
        if (light.amount < .005) return;

        // Only the dots inside the light are drawn; the rest are the CSS background.
        const half = SPACING / 2;
        const x0 = Math.max(half, Math.floor((light.x - RADIUS) / SPACING) * SPACING + half);
        const y0 = Math.max(half, Math.floor((light.y - RADIUS) / SPACING) * SPACING + half);
        for (let y = y0; y <= light.y + RADIUS; y += SPACING) {
            for (let x = x0; x <= light.x + RADIUS; x += SPACING) {
                const distance = Math.hypot(x - light.x, y - light.y);
                if (distance >= RADIUS) continue;
                const t = 1 - distance / RADIUS;
                const f = t * t * (3 - 2 * t) * light.amount;
                ctx.fillStyle = 'rgba(0, 0, 0, ' + (f * .26).toFixed(3) + ')';
                ctx.beginPath();
                ctx.arc(x, y, 1 + f * .9, 0, Math.PI * 2);
                ctx.fill();
            }
        }
    }

    function tick() {
        light.x += (light.tx - light.x) * .2;
        light.y += (light.ty - light.y) * .2;
        light.amount += (light.target - light.amount) * .1;
        draw();
        const moving = Math.abs(light.tx - light.x) > .2 || Math.abs(light.ty - light.y) > .2 ||
            Math.abs(light.target - light.amount) > .003;
        frame = moving ? window.requestAnimationFrame(tick) : null;
    }

    function kick() {
        if (!frame) frame = window.requestAnimationFrame(tick);
    }

    layout.addEventListener('pointermove', function (event) {
        const rect = layout.getBoundingClientRect();
        light.tx = event.clientX - rect.left;
        light.ty = event.clientY - rect.top;
        if (light.amount < .005) {
            light.x = light.tx;
            light.y = light.ty;
        }
        // Dark over the reading panel and while the menu sheet is open.
        const blocked = event.target.closest('.publication-content, .gh-navigation-menu') ||
            layout.querySelector('.gh-navigation.is-open');
        light.target = blocked ? 0 : 1;
        kick();
    });

    layout.addEventListener('pointerleave', function () {
        light.target = 0;
        kick();
    });

    window.addEventListener('resize', resize);
    resize();
})();

/* Crooked subscribe button: it dashes back into place when the reader gets close */
(function () {
    const form = document.querySelector('.publication-subscribe .gh-form');
    if (!form || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const input = form.querySelector('.gh-form-input');
    const button = form.querySelector('.gh-button');
    const REACH = 120;
    let near = false;
    let timer = null;

    form.classList.add('is-crooked', 'no-transition');
    window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
            form.classList.remove('no-transition');
        });
    });

    function update() {
        // Ghost adds loading/success to the form while and after subscribing.
        const settled = form.classList.contains('loading') || form.classList.contains('success');
        const straight = settled || near || document.activeElement === input;
        window.clearTimeout(timer);
        // Only touch the class when it changes: classList writes always notify
        // the MutationObserver below, which would call update() again.
        if (straight) {
            if (!form.classList.contains('is-straight')) form.classList.add('is-straight');
        } else if (form.classList.contains('is-straight')) {
            timer = window.setTimeout(function () {
                form.classList.remove('is-straight');
            }, 500);
        }
    }

    document.addEventListener('pointermove', function (event) {
        // Measured from where the button sits when straight, so it can't run from the cursor.
        const formRect = form.getBoundingClientRect();
        const x = formRect.right - 6 - button.offsetWidth / 2;
        const y = formRect.top + formRect.height / 2;
        const isNear = Math.hypot(event.clientX - x, event.clientY - y) < REACH;
        if (isNear !== near) {
            near = isNear;
            update();
        }
    });

    input.addEventListener('focus', update);
    input.addEventListener('blur', update);
    form.addEventListener('pointerdown', function () {
        near = true;
        update();
    });
    new MutationObserver(update).observe(form, {attributes: true, attributeFilter: ['class']});
})();

/* Add lightbox to gallery and feature images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img, .gh-feature-image'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Reading progress ticks on the post rail */
(function () {
    const scroller = document.querySelector('.post-publication .publication-content');
    const ticks = document.querySelectorAll('.post-rail-progress i');

    if (!scroller || !ticks.length) {
        return;
    }

    function update() {
        const scrollable = scroller.scrollHeight - scroller.clientHeight;
        const ratio = scrollable > 0 ? scroller.scrollTop / scrollable : 0;
        const read = Math.round(ratio * ticks.length);

        ticks.forEach(function (tick, i) {
            tick.classList.toggle('is-read', i < read);
        });
    }

    scroller.addEventListener('scroll', update, {passive: true});
    update();
})();
